import PlanSelectCardsStateDefinition from './PlanSelectCardsStateDefinition';

function planSelectCardsContainerReducer(
  state = PlanSelectCardsStateDefinition.getInitialState()
) {
  return state;
}

export default planSelectCardsContainerReducer;
